import { styled } from '@mui/material/styles';
import background from "../../../assets/background.png";

// Container for main content with sidebar space
export const ContentContainer = styled('div')(({ theme }) => ({
  marginLeft: 200, // Sidebar width
}));

// Paper container with margin
export const StyledPaper = styled('div')(({ theme }) => ({
  margin: theme.spacing(1),
}));

// Background element with image
export const BackgroundElement = styled('div')(({ theme }) => ({
  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${background})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  minWidth: "100%",
  minHeight: "100%",
  margin: 0,
  padding: 0,
  opacity: 1,
})); 